/**
 * Core-100 R2 — CORE-A: how an account entered OptiBay, as the SERVER recorded it at sign-up.
 *
 * `auth.users.raw_user_meta_data.account_type` is user-writable and decides which Terms of Service
 * apply; `profiles.entry_path` is written once by `handle_new_user` and immutable to the person
 * (migration 20270206003300). Read the recorded value; an account with none falls back to 'shop',
 * the default the product has always applied — never to the metadata.
 */
import { supabase } from '@/integrations/supabase/client';

export type EntryPath = 'shop' | 'passport';

export function resolveEntryPath(recorded: string | null | undefined): EntryPath {
  return recorded === 'passport' ? 'passport' : 'shop';
}

export async function fetchRecordedEntryPath(userId: string): Promise<EntryPath> {
  const { data } = await supabase.from('profiles').select('entry_path' as never).eq('id', userId).maybeSingle();
  return resolveEntryPath((data as { entry_path?: string | null } | null)?.entry_path ?? null);
}
